export class AMT {
  id?: any = null;
  person_id?: any = null;
  financial_id?: any = null;
  amt1?: any = null;
  amt2?: any = null;
  amt2a?: any = null;
  amt2b?: any = null;
  amt2c?: any = null;
  amt3?: any = null;
  amt3a?: any = null;
  amt3b?: any = null;
  amt4?: any = null;
  creation_date?: any = null;
  updated_date?: any = null;
}
